import { SearchParams } from '@apply4u/models/search/search-params';

export class AutoComplete {
    Key: string;
    Value: string;
    Latitude:number;
    Longitude:number;
    DisplayValue:string;
    DefaultRadius:number = 0;
}

export class RecentSearchesAutoComplete {
    Id: number;
    Title: string;
    DisplayTitle: string;
    Url: string;
    SearchType: String;
    RecentSearchParams:SearchParams;
}

export class AutoCompleteNew {
    Key: number;
    Value: string;
}